/* import __COLOCATED_TEMPLATE__ from './form-template-form-preview.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();